package tta.destinigo.talktoastro.feature_chat_consultation_new.data.request

import tta.destinigo.talktoastro.feature_chat_consultation_new.persentation.chat_concern.widget.RequestAnswerData
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class AnswerRequest(
    @SerialName("answer")val answerList:List<RequestAnswerData>
)